import {Socket} from 'ngx-socket-io';
import {Observable} from 'rxjs/internal/Observable';
import {Subject} from 'rxjs/internal/Subject';
import {Subscription} from 'rxjs/internal/Subscription';
import {Notification} from '../interfaces/notification-base.interface';
import {NotificationsConfigurationService} from '../services/notifications-configuration.service';

export abstract class NotificationsSystemBase {
  public notifications$: Subject<Notification>;
  protected readonly domain;
  protected readonly notificationSocket: Socket;
  protected onRecieveSubscription: Subscription = null;

  constructor(type: string, notificationSocket: Socket) {
    this.domain = type;
    this.notificationSocket = notificationSocket;
    this.notifications$ = new Subject<Notification>();
    this.listen();
  }

  private _configuration: NotificationsConfigurationService;

  get configuration(): NotificationsConfigurationService {
    return this._configuration;
  }

  set configuration(value: NotificationsConfigurationService) {
    this._configuration = value;
  }

  public notifyCreated(notification: Notification) {
    const eventType = 'Emit';
    const eventName = this.domain + 'Created' + eventType;
    this.notificationSocket.emit(eventName, notification);
  };

  public listen() {
    const eventType = 'Recieved';
    const eventName = this.domain + 'Created' + eventType;
    this.onRecieveSubscription = this.notificationSocket
      .fromEvent(eventName)
      .subscribe((notification: Notification) => {
        
        this.notifications$.next(notification);
      });
  };

  public unlisten() {
    if (this.onRecieveSubscription != null) {
      this.onRecieveSubscription.unsubscribe();
    }
  };

  abstract initNotifications(): Observable<Notification>;

  public triggerTest() {
    this.notificationSocket.emit('test');
  }
}
